import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";

import AimsObjectives from "../components/about/AimsObjectives";
import Awards from "../components/about/Awards";
import BasicDetails from "../components/about/BasicDetails";
import Committee from "../components/about/Committee";
import CoordinatorDesk from "../components/about/CoordinatorDesk";
import DirectorDesk from "../components/about/DirectorDesk";
import Faculty from "../components/about/Faculty";
import History from "../components/about/History";
import PrincipalDesk from "../components/about/PrincipalDesk";

const About = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const activeTab = query.get("tab") || "history";

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />

<main className="page-wrapper">
      <div className="about-hero">
        <div className="about-overlay">
          <h1>About</h1>
          <Breadcrumb />
        </div>
      </div>

      {activeTab === "history" && <History />}

      {activeTab === "aims" && <AimsObjectives />}

      {activeTab === "director" && <DirectorDesk />}

      {activeTab === "principal" && <PrincipalDesk />}

      {activeTab === "coordinator" && <CoordinatorDesk />}

      {activeTab === "committee" && <Committee />}

      {activeTab === "faculty" && <Faculty />}

      {activeTab === "awards" && <Awards />}

      {activeTab === "basic" && <BasicDetails />}

      </main>

      <Footer />
    </>
  );
};

export default About;